import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { get } from '../../utils/Cookie';

import { Container, Nav } from './Layout.style';

const ManageLayout = () => {
	const navigation = useNavigate();
	const { pathname } = window.location;
	console.log('location', pathname);
	const name = get('name');
	const role = get('role');

	const isNotKid = (role) => {
		console.log('role', role);
		const isNotKid = !role?.some((r) => r.name === 'kid');
		const isAdmin = role?.some((r) => r.name === 'admin');
		return isNotKid || isAdmin;
	};

	const isSenior = role?.some((r) => r.name === 'senior');

	return (
		<Container>
			{isNotKid() && (
				<Nav>
					<button
						disabled={role?.some((r) => r.name === 'seoul')}
						className={pathname === '/custom' ? 'selected' : ''}
						onClick={() => {
							navigation('/custom');
						}}>
						리쿠 커스텀
					</button>
					<div className='dash'></div>
					<button
						className={pathname === '/manage' ? 'selected' : ''}
						onClick={() => {
							navigation('/manage');
						}}>
						사용자 관리
					</button>
					<div className='dash'></div>
					<button
						disabled={role?.some((r) => r.name === 'seoul')}
						className={pathname === '/alarm' ? 'selected' : ''}
						onClick={() => {
							navigation('/alarm');
						}}>
						알림
					</button>
					{!isSenior && (
						<>
							<div className='dash'></div>
							<button
								className={pathname === '/persona' ? 'selected' : ''}
								onClick={() => {
									navigation('/persona');
								}}>
								리쿠 캐릭터 설정
							</button>
						</>
					)}
				</Nav>
			)}
			<Outlet />
		</Container>
	);
};

export default ManageLayout;
